import { createContext, useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
// import sha256 from "crypto-js/sha256";
import { useNavigate } from "react-router-dom";
import {
	COLORS,
	// POSITIONS, USER_TYPES
} from "utils/lists.utils";

export const AuthContext = createContext({
	user: null,
	isSignedIn: null,
	login: () => {},
	logout: () => {},
	resetPassword: () => {},
});

const AuthProvider = ({ children }) => {
	const navigate = useNavigate();

	const [isSignedIn, setIsSignedIn] = useState(false);
	const [user, setUser] = useState(null);

	// const [isSignedIn, setIsSignedIn] = useState(true);
	// const [user, setUser] = useState({
	// 	name: "Can",
	// 	surname: "Karaman",
	// 	username: "cankrmn7",
	// 	mail: "can-karaman@gmail.com",
	// 	position: 0, // index for ["Administrator", "Member"]
	// 	companyName: "Spotify",
	// 	companyColor: COLORS[3],
	// 	jobTitle: "CFO",
	// 	phone: "+90 543 343 1957",
	// 	type: 1, // index for ["Accountant", "Client"]
	// });

	// console.log({ user });

	//PART: Funtions
	const login = useCallback(async ({ email, password }) => {
		var errorStatus = null;
		// const encryptedPassword = sha256(password).toString();

		await axios
			.post("/login", {
				email: email,
				password: password,
				// password: encryptedPassword,
			})
			.then((res) => {
				const { sesToken, userInfo } = res.data;
				// userInfo.type = USER_TYPES[userInfo.type];
				// userInfo.position = POSITIONS[userInfo.position];
				setUser(userInfo);
				setIsSignedIn(true);
				axios.defaults.headers.common["access-token"] = sesToken;
				sessionStorage.setItem("user", JSON.stringify({ email, password }));
			})
			.catch((err) => {
				console.log({ err });
				errorStatus = err.response.status;
			});

		return errorStatus;
	}, []);

	const logout = useCallback(() => {
		setUser(null);
		setIsSignedIn(false);
		sessionStorage.removeItem("user");
		navigate("/", { replace: true });
		// navigate("/");
	}, [navigate]);

	const resetPassword = useCallback(async ({ email }) => {
		await axios.post("/resetPassword", { email }).then(console.log).catch(console.error);
	}, []);
	//PART
	useEffect(() => {
		if (sessionStorage.getItem("user")) {
			const { email, password } = JSON.parse(sessionStorage.getItem("user"));
			login({ email, password });
		}
	}, [login]);

	const value = useMemo(
		() => ({ user, isSignedIn, login, logout, resetPassword }),
		[user, isSignedIn, login, logout, resetPassword]
	);
	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthProvider;
